import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { Overlay } from '@angular/cdk/overlay';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { Provider } from '@angular/core';
import { ConfigLacksComponent } from './config-lacks/config-lacks.component';
import { PanelComponent } from './panel/panel.component';
import { TableReadComponent } from './table/read/read.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { StaticsComponent } from './statics/statics.component';
import { CalculosComponent } from './calculos/calculos.component';
import { HomeComponent } from './home/home.component';
import { BalanceComponent } from './balance/balance.component';
import { AgronomicConfigurationComponent } from './balance/agronomic-configuration.component';
import { HelpPopoverComponent } from './balance/help-popover.component';
import { AgentChatChartBlockComponent } from './balance/agent-chat-chart-block.component';
import { PestModelsComponent } from './pest-models/pest-models.component';
import { DecimalPipe } from '@angular/common';
import { SeasonDateFormatsDirective } from './table/read/season-date-formats.directive';

// Scroll strategy estable para mat-select en vistas (Home)
export function matSelectScrollStrategyFactory(overlay: Overlay) {
  return () => overlay.scrollStrategies.reposition();
}

@NgModule({
  declarations: [
    ConfigLacksComponent,
    TableReadComponent,
    PanelComponent,
    DashboardComponent,
    StaticsComponent,
    CalculosComponent,
    HomeComponent,
    BalanceComponent,
    AgronomicConfigurationComponent,
    AgentChatChartBlockComponent,
    HelpPopoverComponent,
    PestModelsComponent,
    SeasonDateFormatsDirective
  ],
  imports: [SharedModule],
  providers: [
    DecimalPipe,
    {
      provide: MAT_SELECT_SCROLL_STRATEGY,
      deps: [Overlay],
      useFactory: matSelectScrollStrategyFactory
    } as Provider
  ]
})
class ViewsModule {}

export { ViewsModule };
